import { ScoutPulse } from './ScoutPulse.js';
import { UAV } from './UAV.js';
import { CarePackage } from './CarePackage.js';
import { SentryTurret } from './SentryTurret.js';
import { NapalmStrike } from './NapalmStrike.js';
import { WatchdogHelo } from './WatchdogHelo.js';
import { Gunship } from './Gunship.js';

/**
 * The ladder.
 *
 * Ordered by cost, and shaped the way the reference list is shaped:
 * information → area denial → direct firepower → a controllable set-piece.
 * The costs are set against a hundred points per kill and a thirty-kill match,
 * so the bottom of the ladder fires several times per match and the top of it
 * lands roughly once, if the player earns it.
 *
 * `name` is what the HUD says. `blurb` is the one line of the callout.
 */
export const STREAKS = [
  {
    id: 'scout_pulse',
    name: 'SCOUT PULSE',
    blurb: 'SONAR PING',
    cost: 500,
    tier: 'recon',
    Impl: ScoutPulse,
  },
  {
    id: 'uav',
    name: 'UAV',
    blurb: 'RECON OVERHEAD',
    cost: 750,
    tier: 'recon',
    Impl: UAV,
  },
  {
    id: 'package',
    name: 'CARE PACKAGE',
    blurb: 'AIRDROP INBOUND',
    cost: 1250,
    tier: 'support',
    Impl: CarePackage,
  },
  {
    id: 'sentry',
    name: 'SENTRY TURRET',
    blurb: 'AUTOMATED GUN',
    cost: 1500,
    tier: 'denial',
    Impl: SentryTurret,
  },
  {
    id: 'napalm',
    name: 'NAPALM STRIKE',
    blurb: 'FIRE CORRIDOR',
    cost: 2000,
    tier: 'denial',
    Impl: NapalmStrike,
  },
  {
    id: 'helo',
    name: 'WATCHDOG HELO',
    blurb: 'AIR SUPPORT ON STATION',
    cost: 3000,
    tier: 'power',
    Impl: WatchdogHelo,
  },
  {
    id: 'gunship',
    name: 'GUNSHIP',
    blurb: 'YOU HAVE THE GUNS',
    cost: 4500,
    tier: 'ultimate',
    Impl: Gunship,
  },
];

export const STREAK_BY_ID = new Map(STREAKS.map((s) => [s.id, s]));
